import { useMemo } from 'react';
import { useActiveOwners } from 'src/features/common/collectible/hooks/use-nft-owners';
import { useProfile } from 'src/features/common/profile/hooks/profile.hooks';
import { useMyWalletsById } from 'src/features/common/wallet/hooks/use-my-wallets-by-id';

export const useIsActiveNftOwner = (): boolean => {
    const activeOwners = useActiveOwners();
    const myWallets = useMyWalletsById();
    const { user } = useProfile() || {};

    return useMemo(() => {
        if (!user || !activeOwners.totalCount) {
            return false;
        }
        return !!activeOwners.items.find((owner) => +owner.copies && myWallets[owner.address]);
    }, [activeOwners.items, activeOwners.totalCount, myWallets, user]);
};
